import { render, staticRenderFns } from "./data_keluarga.vue?vue&type=template&id=72982bf2&"
import script from "./data_keluarga.vue?vue&type=script&lang=js&"
export * from "./data_keluarga.vue?vue&type=script&lang=js&"
import style0 from "./data_keluarga.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup,QBtn,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions})
